import { useCreateOrUpdateStudentMutation } from '@innovamat/glow-api-client';

export default function useStudentsActions() {
  const createOrUpdateStudent = useCreateOrUpdateStudentMutation();

  return {
    createOrUpdateStudent,
  };
}
